import * as React from "react";

import { InputNumber, Slider } from "antd";

import {
    casterWithIdWrapper,
    FormComponentProps,
    ValidationRule,
    validationRulesConverter,
} from "utils/form";

import * as theme from "./theme.css";

import { BaseFormField } from "./index";

interface SliderInputCommonProps {
    label: string;
    min?: number;
    max?: number;
    step?: number;
    parser?: (displayValue: string | undefined) => number | string;
    formatter?: (value: number | string | undefined) => string;
}

interface CreateSliderInputProps<ID extends string, R>
    extends
        FormComponentProps<ID, number | undefined, R>,
        SliderInputCommonProps {
    id: ID;
    initialValue: number | undefined;
    validators?: ValidationRule<number | undefined>[];
    empty?: boolean;
}

class CreateSliderInput<ID extends string, R> extends React.PureComponent<
    CreateSliderInputProps<ID, R>
> {
    private innerField = React.createRef<HTMLInputElement>();

    render = () => {
        const { label } = this.props;

        return (
            <BaseFormField
                getComponent={this.getComponent}
                onClick={this.onLabelClick}
                hasFeedback={false}
                label={label}
            />
        );
    };

    getComponent = () => {
        const {
            form,
            id,
            validators,
            label,
            parser,
            formatter,
            min,
            max,
            step,
            initialValue,
        } = this.props;
        const { getFieldDecorator, setFieldsValue, getFieldValue } = form;
        const caster = casterWithIdWrapper<number | undefined>();

        return (
            <div className={theme.sliderInput}>
                <Slider
                    className={theme.slider}
                    onChange={(value) =>
                        setFieldsValue(caster(id, form, value))
                    } // we don't use the 2 knob variant
                    value={getFieldValue(id)}
                    min={min}
                    max={max}
                    step={step}
                />
                {getFieldDecorator(id, {
                    rules: validationRulesConverter<number | undefined>()(
                        id,
                        form,
                        validators,
                        label
                    ),
                    valuePropName: "value",
                    validateFirst: true,
                    preserve: true,
                    initialValue,
                })(
                    <InputNumber
                        className={theme.input}
                        ref={this.innerField}
                        parser={parser}
                        formatter={formatter}
                        step={step}
                        min={min}
                        max={max}
                    />
                )}
            </div>
        );
    };

    onLabelClick = () => {
        const field = this.innerField.current;
        if (field) {
            field.focus();
        }
    };
}

export { CreateSliderInput, type CreateSliderInputProps };
